import { render } from "./MusicalListComponent.vue?vue&type=template&id=aa8b0184&ts=true"
import script from "./MusicalListComponent.vue?vue&type=script&lang=ts"
export * from "./MusicalListComponent.vue?vue&type=script&lang=ts"

import "./MusicalListComponent.vue?vue&type=style&index=0&id=aa8b0184&scope=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__